import Accordion from "../../../../common/components/CustomAccordion/Accordion";
import faqData from "../../../../data/faqs.json";

const ContactUsFaqs = () => {
  return (
    <div className="flex flex-col gap-14 p-10 bg-lightGray shadow-blurShadow rounded-xl">
      <h2 className="text-primary text-[28px] font-semibold tracking-[0] leading-[100%]">
        FAQs
      </h2>
      <Accordion
        items={faqData.faqs.slice(0, 6)}
        singleOpen={false}
        durationClass="duration-300"
        easeClass="ease-out"
      />
    </div>
  );
};

export default ContactUsFaqs;
